import type {PermissionType, Permission} from '@hconnect/apiclient'
import {ApiClient, getPermissionsByUserId} from '@hconnect/apiclient'
import {useUserContext} from '@hconnect/login'
import {useQuery} from '@tanstack/react-query'
import {useCallback} from 'react'

import {parseAndFilterPermissions} from '../../helpers/parseAndFilterPermissions'

export const usePermissionsParsedQuery = (permissionTypes?: PermissionType[]) => {
  const {loggedUser} = useUserContext()

  const userId = loggedUser?.user_id

  const selector = useCallback(
    (permissions: Permission[]) => parseAndFilterPermissions(permissions, permissionTypes),
    [permissionTypes]
  )

  // Only call useQuery if userId exists
  return useQuery({
    queryKey: ['permissions', userId],
    queryFn: () => getPermissionsByUserId(ApiClient.axiosInstance)(userId!),
    enabled: !!userId,
    select: selector
  })
}
